<template>
  <div class="text-center pa-10">
    <h1 class="text-h4 mb-4">404 - Page Not Found</h1>
    <p>This page doesn't exist.</p>
  </div>
</template>

<script>
export default {
  name: 'AdminNotFound'
};
</script>
